import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    questionnaireInvites: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_QUESTIONNAIREINVITE_SELECT_IDS (store, ids) {
      store.questionnaireInvites.selectIds = ids
    },
    REMOVE_QUESTIONNAIREINVITE_SELECT_IDS (store, ids) {
      store.questionnaireInvites.selectIds = store.questionnaireInvites.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_QUESTIONNAIREINVITE_SELECT_ID (store, id) {
      store.questionnaireInvites.selectId = id
    },
    SET_QUESTIONNAIREINVITE_FILTERS (store, filters) {
      store.questionnaireInvites.filters = filters
    },
    SET_QUESTIONNAIREINVITE_PAGINATE (store, val) {
      store.questionnaireInvites.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getQuestionnaireInvites: (store, getters) => {
      return store.questionnaireInvites.selectIds.map((id) => {
        return getters['entities/questionnaireInvites/find'](id)
      })
    },
    getQuestionnaireInvitesFilters: (store, getters) => {
      return store.questionnaireInvites.filters
    },
    getQuestionnaireInvitesPaginate: (store, getters) => {
      return store.questionnaireInvites.paginate
    },
    getQuestionnaireInvite: (store, getters) => {
      return getters['entities/questionnaireInvites/find'](store.questionnaireInvites.selectId) || {}
    }
  },
  actions: {
    /*
    selectQuestionnaireInvites
    */
    selectQuestionnaireInvites ({commit, dispatch, getters, state}, filters) {
      return dispatch('getQuestionnaireInvites', filters)
      .then((response) => {
        commit('SET_QUESTIONNAIREINVITE_FILTERS', filters)
        commit('SET_QUESTIONNAIREINVITE_PAGINATE', response)
        commit('SET_QUESTIONNAIREINVITE_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectQuestionnaireInvites
    */
    refreshSelectQuestionnaireInvites ({commit, dispatch, getters, state}) {
      return dispatch('selectQuestionnaireInvites', getters.getQuestionnaireInvitesFilters)
    },
    /*
    selectQuestionnaireInvite
    */
    selectQuestionnaireInvite ({commit, dispatch, getters, state}, id) {
      return dispatch('getQuestionnaireInviteById', id)
      .then((response) => {
        commit('SET_QUESTIONNAIREINVITE_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getQuestionnaireInvites
    */
    getQuestionnaireInvites ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/questionnaire-invites`, {params: filters})
      .then((response) => {
        return dispatch('entities/questionnaireInvites/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.questionnaireInvites || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getQuestionnaireInviteById
    */
    getQuestionnaireInviteById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/questionnaire-invites/${id}`)
      .then((response) => {
        return dispatch('entities/questionnaireInvites/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.questionnaireInvites[0]
      })
    },
    /*
    createQuestionnaireInvite
    */
    createQuestionnaireInvite ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/questionnaire-invites`, data)
      .then((response) => {
        return dispatch('entities/questionnaireInvites/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.questionnaireInvites[0]
      })
    },
    /*
    updateQuestionnaireInvite
    */
    updateQuestionnaireInvite ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/questionnaire-invites/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/questionnaireInvites/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.questionnaireInvites[0]
      })
    },
    /*
    deleteQuestionnaireInvite
    */
    deleteQuestionnaireInvite ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/questionnaire-invites/${id}`)
      .then((response) => {
        commit('REMOVE_QUESTIONNAIREINVITE_SELECT_IDS', [id])
        dispatch('entities/questionnaireInvites/delete', id)
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/QuestionnaireInvite.js